import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, NavParams, Platform } from '@ionic/angular';
import { StarPRNT } from '@awesome-cordova-plugins/star-prnt/ngx';

@Component({
    selector: 'app-settings-star-micronics-receipt-printer-finder',
    templateUrl: './settings-star-micronics-receipt-printer-finder.page.html',
    styleUrls: ['./settings-star-micronics-receipt-printer-finder.page.scss'],
})
export class SettingsStarMicronicsReceiptPrinterFinderPage implements OnInit {

    params = {};
    keep_looking = true;
    printers = [];

    constructor(
        public navParams: NavParams,
        public modalController: ModalController,
        public alertController: AlertController,
        private platform: Platform,
        private starprnt: StarPRNT
    ) { }

    ngOnInit() {
        
    }

    ionViewDidEnter() {
        this.keep_looking = true;
        this.findPrinters();
    }

    async findPrinters() {
        try {
            this.printers = await this.starprnt.portDiscovery('All');
            if(this.keep_looking) {
                this.findPrinters();
            }
        } catch (e) {
            console.error(e);
        }        
    }

    close() {
        this.keep_looking = false;
        this.modalController.dismiss();
    }

    select(printer_index) {
        this.keep_looking = false;
        let printer = this.printers[printer_index];
        this.params['port_name'] = printer.portName;
        this.modalController.dismiss(this.params);
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
